import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, IndexLink } from 'react-router';
import Sticky from 'react-stickynode';
import classNames from 'classnames';

import SmallTopBanner from '../../../promotions/SmallTopBanner';

/* css imports */
import './SecondaryNav.less';

// these strings allow promo banner when present in the URL
export const BANNER_WHITELIST_URLS = [
  '/wedding-planning/invitations',
  '/wedding-planning/paper',
  '/wedding-planning/save-the-date',
  '/wedding-planning/enclosures',
  '/wedding-planning/menus',
  '/wedding-planning/programs',
  '/wedding-planning/thank-you-cards',
  '/wedding-planning/draper-james'
];

const DropdownNavItem = (props) => {
  const {
    navUrl,
    navText,
    notReactLink,
    handleMouseClick,
    guestRequestCount,
    receivesNotifications
  } = props;
  return (
    <li
      className={
        guestRequestCount === 0 && receivesNotifications ? 'hide-nav-item' : null
      }
    >
      {notReactLink ? (
        <a href={navUrl} onClick={handleMouseClick}>
          {navText}
        </a>
      ) : (
        <Link to={navUrl} onClick={handleMouseClick}>
          {navText}
          {receivesNotifications && guestRequestCount !== 0 && (
            <span className="drop-down-badge badge">{guestRequestCount}</span>
          )}
        </Link>
      )}
    </li>
  );
};

DropdownNavItem.defaultProps = {
  notReactLink: false
};

DropdownNavItem.propTypes = {
  handleMouseClick: PropTypes.func.isRequired,
  navUrl: PropTypes.string.isRequired,
  navText: PropTypes.string.isRequired,
  notReactLink: PropTypes.bool,
  guestRequestCount: PropTypes.number,
  receivesNotifications: PropTypes.bool
};

class WebsiteNavItem extends Component {
  constructor(props) {
    super(props);
    this.handleMouseHover = this.handleMouseHover.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
    this.handleMouseClick = this.handleMouseClick.bind(this);
    this.hideNavItem = this.hideNavItem.bind(this);
    this.state = {
      isHovering: false,
      guestRequestCount: []
    };
  }

  handleMouseHover() {
    this.setState({ isHovering: true });
  }

  handleMouseOut() {
    this.setState({ isHovering: false });
  }

  handleMouseClick() {
    this.setState({ isHovering: false });
  }

  hideNavItem(navItem) {
    const { userContext } = this.props;
    return navItem.showFn && !navItem.showFn(userContext);
  }

  render() {
    const { navItem, idx, altActive, editActive, altActiveGlobal, guestRequestCount, activeCardEvent } = this.props;
    const mainNavHasChildren = Array.isArray(navItem);
    const mainNavItem = mainNavHasChildren ? navItem[0] : navItem;
    const navItemChildren = mainNavHasChildren ? navItem[1] : null;
    const navItemDropdownClassNames = classNames('dropdown', {
      'dropdown--active': this.state.isHovering,
    });
    const navItemClassNames = classNames({
      active: (mainNavItem.navText === 'Edit Pages' && editActive)
        || (mainNavItem.navText === 'View Designs' && altActive)
        || (mainNavItem.navText === 'Website' && altActive)
        || (mainNavItem.navText === 'Track RSVPs' && altActiveGlobal)
        || (mainNavItem.navText === 'Your Orders + Drafts' && altActive)
        || (mainNavItem.navText === 'Save The Dates' && activeCardEvent === 'SAVE_THE_DATE')
        || (mainNavItem.navText === 'Invitations' && activeCardEvent === 'INVITATION')
        || (mainNavItem.navText === 'Enclosure Cards' && activeCardEvent === 'DETAILS')
        || (mainNavItem.navText === 'Menus' && activeCardEvent === 'MENU')
        || (mainNavItem.navText === 'Programs' && activeCardEvent === 'PROGRAM')
        || (mainNavItem.navText === 'Thank You Cards' && activeCardEvent === 'THANK_YOU'),
      dropdown__trigger: mainNavHasChildren,
    });
    if (this.hideNavItem(mainNavItem)) {
      return null;
    }
    return mainNavHasChildren ? (
      <li
        key={idx}
        onMouseEnter={this.handleMouseHover}
        onMouseLeave={this.handleMouseOut}
        className={navItemDropdownClassNames}
      >
        {mainNavItem.notReactLink ? (
          <a
            href={mainNavItem.navUrl}
            className={navItemClassNames}
            onClick={this.handleMouseClick}
          >
            {mainNavItem.navText} <i className="caret" />
          </a>
        ) : (
          <Link
            to={mainNavItem.navUrl}
            href={mainNavItem.navUrl}
            activeClassName="active"
            className={navItemClassNames}
            onClick={this.handleMouseClick}
          >
            {mainNavItem.navText} <i className="caret" />
            {guestRequestCount !== 0 && navItem[0].receivesNotifications && (
              <span className="top-level-badge" />
            )}
          </Link>
        )}
        <div className="dropdown__content">
          <ul className="dropdown-menu dropdown-menu-left">
            {navItemChildren.map((childNavItem, childIdx) => (this.hideNavItem(childNavItem) ? null : (
              <DropdownNavItem
                key={childIdx}
                handleMouseClick={this.handleMouseClick}
                {...childNavItem}
                guestRequestCount={guestRequestCount}
              />
            )))}
          </ul>
        </div>
      </li>
    ) : (
      <li key={idx}>
        {mainNavItem.notReactLink ? (
          <a
            href={mainNavItem.navUrl}
            className={navItemClassNames}
            onClick={this.handleMouseClick}
          >
            {mainNavItem.navText}
          </a>
        ) : (
          <IndexLink
            key={idx}
            onlyActiveOnIndex
            to={
              mainNavItem.navUrl === '/wedding-planning/projects'
                ? '/wedding-planning/projects/drafts'
                : mainNavItem.navUrl
            }
            activeClassName="active"
            className={navItemClassNames}
          >
            {mainNavItem.navText}
            {mainNavItem.receivesNotifications && guestRequestCount !== 0 && (
              <span className="mobile-badge" />
            )}
          </IndexLink>
        )}
      </li>
    );
  }
}

WebsiteNavItem.propTypes = {
  navItem: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))])
    )
  ]),
  idx: PropTypes.number,
  altActive: PropTypes.bool,
  editActive: PropTypes.bool,
  altActiveGlobal: PropTypes.bool,
  guestRequestCount: PropTypes.number,
  userContext: PropTypes.shape({}),
  activeCardEvent: PropTypes.string
};

class WebsiteNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      altActive: false,
      editActive: false,
    };
  }

  render() {
    const { navItems, altActive, editActive, altActiveGlobal, activeGuestPage, guestRequestCount, userContext, activeCardEvent } = this.props;  // eslint-disable-line
    const nav = [];
    navItems.forEach((navItem, idx) => {
      const navEl = navItem.navUrl === '/wedding-planning' ? (
        <li key={idx}>
          <IndexLink key={idx} onlyActiveOnIndex to={navItem.navUrl} activeClassName="active">{navItem.navText}</IndexLink>
        </li>
      ) : (
        <WebsiteNavItem
          key={idx}
          navItem={navItem}
          idx={idx}
          altActive={altActive}
          editActive={editActive}
          altActiveGlobal={altActiveGlobal}
          activeGuestPage={activeGuestPage}
          guestRequestCount={guestRequestCount}
          userContext={userContext}
          activeCardEvent={activeCardEvent}
        />
      );
      nav.push(navEl);
    });

    // show Promo banner when matching URL whitelist
    const renderBanner = BANNER_WHITELIST_URLS.some(
      route => window.location.pathname.indexOf(route) > -1
    );

    return (
      <div id="sub-nav" className="menu-container-v2 row">
        <Sticky className="minimal-top-bar clearfix" top={60}>
          <div className="website-nav">
            <div className="menu-section">
              <ul className="preauth-menu">{nav}</ul>
            </div>
          </div>
          <SmallTopBanner tag="promo-30" shouldRender={renderBanner} />
        </Sticky>
      </div>
    );
  }
}

WebsiteNav.propTypes = {
  navItems: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))])
      )
    ])
  ),
  altActive: PropTypes.bool,
  editActive: PropTypes.bool,
  altActiveGlobal: PropTypes.bool,
  activeGuestPage: PropTypes.bool,
  guestRequestCount: PropTypes.number,
  userContext: PropTypes.shape({}),
  activeCardEvent: PropTypes.string
};

const mapStateToProps = state => ({
  weddingAccount: state.wedding.account,
  altActiveGlobal: state.guestList.guests.altActiveGlobal,
  guestRequestCount: state.publicWebsite.guestRequestCount,
  userContext: state.user.userContext
});

export default connect(
  mapStateToProps,
  null
)(WebsiteNav);



// WEBPACK FOOTER //
// ./src/components/common/header/SecondaryNav/SecondaryNav.jsx